import { friendlyApiErrorMessage } from 'src/app/services/api-error-notifier.service';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { FilterService } from 'src/app/services/filter.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { forkJoin } from 'rxjs';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-control-chart-card',
    templateUrl: './control-chart-card.component.html',
    styleUrls: ['./control-chart-card.component.scss'],
    standalone: false
})
export class ControlChartCardComponent implements OnInit, OnDestroy {
  static key = 100704;

  @Input("item") item: any;
  @Input("pageKey") pageKey: any;
  heading: any;
  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();
  @ViewChild("ControlCharDiv", { static: true }) ControlCharDiv!: ElementRef;
  config: any;
  AllcommentData: any;
  data: any={};
  isDataLoaded = false;
  reqSubcription: Subscription[] = [];
  sourceName: any;
  parentData:any
  childData:any;
  dashboardKey:any;
  error_name:any;
  
  constructor(
    private filterService: FilterService,
    private route: ActivatedRoute,
    private httpClient: HttpClient,
    private apiService: ApiService,
    private navigationService: NavigationService
  ) {

    this.route.params.subscribe((p: any) => {
      // Query Params
      this.route.queryParams.subscribe((params:any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        this.dashboardKey = decryptedParams["ds_key"];
      });
    });

    this.reqSubcription.push(
      this.filterService.filterQuery.subscribe((query: any) => {
        this.getcommentsData()
        this.loadApiData();
        // this.getcommentsData();
      })
    );
  }
  ngOnInit(): void {
    this.item;

    const observer = new ResizeObserver((e: any) => {
      setTimeout(() => {
        this.onSizeChange.emit(e[0].contentRect.height);
      }, 0);
    });
    observer.observe(this.ControlCharDiv.nativeElement);
    this.loadlineConfig();
  }

  loadlineConfig() {
    this.heading = this.item.config["report_heading"];
    // this.config = {
    //   colours: {
    //     Biologics: "#8C23E6",
    //     Onco360: "#E223E6",
    //     Amber: "#FFCD4A",
    //     RxCrossroads: "#645DD7",
    //     TEST1: "gold",
    //     TEST2: "black",
    //     TEST3: "purple",
    //     TEST4: "orange",
    //   },
    //   period: "weekly",
    //   xAxisLabel: this.item.config["x_axis"]["api_resp_column_display_nm"],
    //   yAxisLabel: this.item.config["y_axis"]["api_resp_column_display_nm"],
    //   xAxisVar: this.item.config["x_axis"]["api_resp_column_nm"],
    //   yAxisVar: this.item.config["y_axis"]["api_resp_column_nm"],
    //   value_column: this.item.config["value_column"]["api_resp_column_nm"],
    //   secondary_value_column:
    //     this.item.config["secondary_value_column"]?.["api_resp_column_nm"] ||
    //     null,
    //   displayType: "value",
    // };
  }

loadApiData(sourceName?: string) {
  const apiConfig = this.item.config || {};
  const parentApiKey = apiConfig["list_of_prop_api"]?.api_key;
  const childApiKey = apiConfig["list_of_api"]?.api_key;

  if (!this.filterService.isEmptyObject(this.filterService.baseQuery)) {
    const commonQuery = {
      ...this.filterService.baseQuery,
      report_typ: 'D',
      time_cycle: this.filterService.report_type,
      report_key: undefined,
      module_key: this.apiService.getModuleKey()
    };
        
    let endPoint = this.item.config?.["list_of_api_endpoint"] || '';

    const parentQuery = { ...commonQuery, api_key: parentApiKey };
    const childQuery = { ...commonQuery, api_key: childApiKey };

    const parentRequest: Observable<any[]> = this.httpClient.post<any[]>(
      `${this.apiService.apiBaseUrl}/${endPoint || this.apiService.executionUrl}`,
      parentQuery
    );

    const childRequest: Observable<any[]> = this.httpClient.post<any[]>(
      `${this.apiService.apiBaseUrl}/${endPoint || this.apiService.executionUrl}`,
      childQuery
    );

    const subscription = forkJoin([parentRequest, childRequest]).subscribe({
      next: ([parentRes, childRes]: [any[], any[]]) => {
        this.parentData = parentRes || [];
        this.childData = childRes || [];
        this.getData();
        this.error_name = '';
      },
      error: (err:any) => {
        this.parentData = [];
        this.childData = [];
        this.getData();
        this.error_name = friendlyApiErrorMessage(err);
      }
    });

    this.reqSubcription.push(subscription);
  }
}

  getcommentsData() {
    // API Payloads
    const commentType = this.item?.config?.comment_type?.value|| this.item?.config?.comment_type;
    let postdata: any = { report_typ: "S", comment_typ: (this.dashboardKey == 20230515110017 || commentType == 'dpmed'||commentType == 'demd') ? (commentType || 'CC') : 'CCO', api_key: "100132"};
    // debugger
    this.reqSubcription.push(this.filterService.commentsQuery(postdata).subscribe((res: any) => {
      this.AllcommentData = res ? res : [];
    }, err => {
      console.log("Control Chart Comment Api Error")
      this.AllcommentData = []
    }));
  }

  getData() {
    if (this.parentData?.length && this.childData?.length) {
      this.data = this.childData;
    } else if (!this.childData?.length) {
      this.data = [];
    } else if (!this.parentData?.length) {
      this.data = this.childData;
    }
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }
}